import { useStore } from '@nuxtjs/composition-api'
import { NamespacedStore } from '~/models/store/types'
import { getNamespacedStore } from '~/utils/store'

export function useNamespacedStore<S = any, R = any>(
  namespace: string
): NamespacedStore<S> {
  return getNamespacedStore<S, R>(useStore<R>(), namespace)
}
